import defaultTheme from 'tailwindcss/defaultTheme';

export default {
    content: [
        './assets/js/**/*.{html,js,ts,tsx}',
        '!./htmlcov/**/*', // Prevent wasting time on the coverage folders.
        './**/*.html',
        '!./node_modules/**/*',
    ],
    theme: {
        extend: {
            colors: {
                'main-background': '#FAFAFA',
                'main-background-odd': '#EFEFEF',
                'form-text': '#5C6160',
                'form-warning': 'rgb(252, 165, 165)',
                'menu-background': 'rgba(255, 255, 255, 0.2)',
                'menu-border': '#666666',
                'data-type-grey': 'rgb(245, 245, 245)',
                'disabled-data-type-button': 'rgb(228, 228, 228)',
                'light-gray': 'rgb(210, 210, 210)',
                'disabled-data-type-button-border-hover': 'rgb(185 163 34)',
                'menu-color': 'rgb(119,119,119)',
                'hc-dark-grey': '#595959',
                'graph-border-grey': 'rgba(151,151,151,0.25)',
                'button-hover': 'rgb(230,198,7)',
                'menu-hover': 'rgb(238,238,238)',
                'grey-graph-overlay': 'rgba(0,0,0,0.1)',
                'yellow-graph-overlay': 'rgba(248,218,40,0.25)',
                primary: '#F8DA28',
                secondary: '#B0B0B0',
                success: '#34C759',
                error: '#F34E4E',
                warning: '#FFAD31',
                'warning-strong': '#D98B0D',
                'gray-outline': '#D9D9D9',
                'oslo-gray': '#848888',
                'dark-gray': '#9DA1AD',
                'daily-values-yellow': '#FFB000',
                'daily-values-orange': '#FE6100',
                'daily-values-magenta': '#DC267F',
                'daily-values-purple': '#785EF0',
                'daily-values-blue': '#648FFF',
                'graph-blue': '#4B5CF1',
                'banner-green': '#69A84F',
                'notification-border': '#DEE1E2',
                'notification-success': '#7ED321',
                'notification-info': '#4A90E2',
                'notification-warning': '#F8E71C',
                'notification-error': '#D0021B',
                input: {
                    green: '#30701A',
                    orange: '#D97826',
                    red: '#D53419',
                },
            },
            fontFamily: {
                sans: ['Titillium Web', ...defaultTheme.fontFamily.sans],
                display: ['Sora', ...defaultTheme.fontFamily.sans],
            },
            screens: {
                '2xl': '1600px',
                xl: '1240px',
            },
            boxShadow: {
                '448xl': '4px 4px 8px rgba(0, 0, 0, 0.25)',
                '044xl': '0px 4px 4px rgba(0, 0, 0, 0.25)',
                menu: '0 0.4em 0.6em 0 rgba(217, 226, 233, 0.5)',
                select: '0 2px 0 0 rgba(0, 0, 0, 0.1)',
                'floating-menu': '2px 3px 5px #b0b0b0',
            },
            width: {
                90: '22.5rem',
                571: '571px',
            },
            letterSpacing: {
                widened: '0.22px',
            },
            borderWidth: {
                0.5: '0.5px',
            },
            zIndex: {
                nav: '98',
                'modal-overlay': '99',
                modal: '100',
                'floating-menu': '101',
            },
            keyframes: {
                slideUp: {
                    '0%': { transform: 'translateY(100%)' },
                    '25%': { transform: 'translateY(75%)' },
                    '50%': { transform: 'translateY(50%)' },
                    '75%': { transform: 'translateY(25%)' },
                    '100%': { transform: 'translateY(0%)' },
                },
                shake: {
                    '0%, 100%': { transform: 'translateX(0)' },
                    '15%, 45%, 75%': { transform: 'translateX(-5px)' },
                    '30%, 60%': { transform: 'translateX(5px)' },
                },
            },
            animation: {
                'slide-up': 'slideUp 0.3s linear',
                shake: 'shake 0.5s cubic-bezier(.36,.07,.19,.97) both',
            },
            fontSize: {
                xxs: '0.5rem',
                '2xs': ['10px', '14px'] as [fontSize: string, lineHeight: string],
            },
        },
    },
};
